import { buildChildURL } from '@centric-os/helpers';
import type { RouteRecordRaw } from 'vue-router';
import { LocalMenuGroupRouteNames, LocalMenuGroupRoutePathNames } from '../../../../enums';

const Component = () => import('./LocalBrandModifiers.vue');

export default {
  path: buildChildURL(
    LocalMenuGroupRoutePathNames.MODIFIERS,
    LocalMenuGroupRoutePathNames.MOD_GROUP_ID,
  ),
  name: LocalMenuGroupRouteNames.BRAND_MODIFIERS,
  component: Component,
} as RouteRecordRaw;
